import React from 'react'
import ServiceCard from './ServiceCard'
import { Col } from 'reactstrap'
import weatherImg from '../assets/images/weather.png'
import guideImg from '../assets/images/guide.png'
import customizationImg from '../assets/images/customization.png'

const servicesData = [
    {
        imgUrl: weatherImg,
        title: 'Wild and Beach Adventures',
        desc: 'Experience Kenyan wild adventures with packages that include wildlife safaris in parks like Masai Mara and relaxing beach getaways to Diani or Watamu. Enjoy the perfect mix of adventure and tranquility.',
    },
    {
        imgUrl: guideImg,
        title: 'Professional tour guides',
        desc: 'Our knowledgeable and friendly tour guides are passionate about Kenya. They’ll enhance your experience with local insights, wildlife facts, and cultural stories.',
    },
    {
        imgUrl: customizationImg,
        title: 'Transport And Accomodation',
        desc: 'Enjoy seamless travel with our reliable transport services and handpicked lodges and camps for a comfortable stay. Giving you the best',
    },
]


const ServiceList = () => {
  return (
    <>
      {
        servicesData.map((item, index)=> (< Col lg='3' md='6' sm='12' className='mb-4' key={index}>
            <ServiceCard item={item} />
            </Col>
            ))}
    </>
  )
}

export default ServiceList
